import './Contact.css'

const Footer = () => {
   
    return ( 
        <div className="footer">
            <hr />
            <h2>Copyright © 2021 NaoufelBahassoune . All rights reserved</h2>
            <h2>Built with 👨‍💻  in ReactJS <span>NaoufelBahassoune</span></h2>
        
</div>
    )
}
 
export default Footer;